<script>
	import { mapState ,mapActions } from "vuex";
	import IconReconoce from "@/assets/img/icon/section/IconReconoce.vue";
	import UploadImageForm from "@/components/formulario/UploadImageForm.vue";
	import ModalReconoceForm from "@/components/intranet/reconoce/ModalReconoceForm.vue";
	import ReconoceColaboradoresList from "@/components/intranet/reconoce/ReconoceColaboradoresList.vue";
	import Spinner from "@/components/intranet/Spinner.vue";

	export default {
		components: {
			IconReconoce,
			UploadImageForm,
			ModalReconoceForm,
			ReconoceColaboradoresList,
			Spinner
		},
		data() {
			return {
				colaborador: {},
				relacion_laboral: [],

				loadingColaboradores: true,

				//FORM
				form: {
					valor: "",
					relacion: "",
					argumento: "",
					imagen: ""
				},
				//Error
				errorForm: false,
				show_spinner: false
			}
		},
		computed: {
			...mapState("ReconoceModule", [
				"valoresReconocimientos", 
				"relacionesReconocimientos", 
				"usuarios"
			]),

			validation() {
				return {
					valor: !!this.form.valor.nombre_valor,
					relacion: !!this.form.relacion,
					argumento: !!this.form.argumento,
				}
			},
			isValid() {
				let validation = this.validation
				return Object.keys(validation).every(function (keys){
					return validation[keys]
				})
			},
		},
		async created() {
			await this.getColaboradores();
			await this.getRelacionLaboral();
			await this.getValoresReconocimiento();
		},
		methods: {
			...mapActions("ReconoceModule", [
				"getValoresReconoce", 
				"getRelacionesReconocimiento", 
				"getUsuariosReconocer", 
				"crearReconocimiento"
			]),

			cargarDatosModal() {
				if (this.isValid) {
					try {
						this.errorForm = false;
					} catch (error) {
						console.log(error);
					}
				} else {
					this.errorForm = true;
				}
			},

			async enviarReconocimiento() {
				this.show_spinner = true;
				let imagenForm = "";
				let formatoForm = "";
				if (this.form.imagen.includes('base64')) {
					try {
						imagenForm  = this.form.imagen.split(/:|;|,/)[3];
						formatoForm = this.form.imagen.split(/:|;|,/)[1];
					} catch(e) {
						console.log("Falla al momento de obtener imagen en reconocimiento");
					}
				}
				const payload = {
					id_reconocido: [this.colaborador.id_usuario],
					imagen: imagenForm,
					formato: formatoForm,
					comentario: this.form.argumento,
					id_valor_comportamiento: this.form.valor.id_valor,
					id_relacion: this.form.relacion.id_relacion,
					id_reconocedor: this.$ls.get("user").id_usuario,
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_superior: [],
					nombre_grupo: "",
					id_tipo: "1"
				};
				const data = await this.crearReconocimiento(payload);
				this.show_spinner = false;

				if (data.id_reconocimiento) {
					this.toastReconocimientoSuccess();
					let btnCerrarModal = document.getElementById("cerrar-modal-reconoce");
					btnCerrarModal.click();
					this.$router.push({ name:"Reconoce" });
				} else {
					this.toastReconocimientoError();
				}
			},
			//GET
			async getColaboradores() {
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk,
					id_usuario: this.$ls.get("user").id_usuario,
				}
				await this.getUsuariosReconocer(data_);
				this.colaborador = this.usuarios[0];
				this.loadingColaboradores = false;
			},
			async getRelacionLaboral() {
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk
				}
				await this.getRelacionesReconocimiento(data_);
				this.relacion_laboral = this.relacionesReconocimientos;
			},
			async getValoresReconocimiento() {
				let data_ = {
					id_empresa: this.$ls.get("user").id_empresa_fk
				}
				await this.getValoresReconoce(data_);
			},

			//EMIT
			capturaColaborador(item) {
				this.colaborador = item;
			},
			capturaImagen(imagen) {
				this.form.imagen = imagen;
			},

			toastReconocimientoSuccess() {
				this.$toast.open({
					message: "Reconocimiento enviado exitosamente.",
					type: "success",
					duration: 6000,
					position: "top-right",
				});
			},
			toastReconocimientoError() {
				this.$toast.open({
					message: "Error en envío de reconocimiento. Por favor recarga la página e intenta nuevamente.",
					type: "error",
					duration: 6000,
					position: "top-right",
				});
			},

		}
	}
</script>
<template>
	<section id="nuevo-reconocimiento">

		<div class="row">
			<div class="col-12 mb-0">
				<h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
				<IconReconoce class="me-2 icon-svg-45"/>
				Nuevo reconocimiento
				</h1>
		
				<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item">
					<router-link 
						to="/home"
						class="color-main"
					>
						<font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
						Inicio
					</router-link>
					</li>
					<li class="breadcrumb-item">
					<router-link 
						to="/reconoce"
						class="color-main"
					>
						<font-awesome-icon icon="fa-solid fa-star"></font-awesome-icon>
						Reconoce
					</router-link>
					</li>
					<li class="breadcrumb-item text-capitalize active">
						Nuevo reconocimiento
					</li>
				</ol>
				</nav>
			</div>
		</div>

		<div class="row d-flex mt-2">
			<div class="col-12 col-lg-8 mb-3 mb-lg-0 d-flex align-items-center">
				<p class="text-secondary h5-custom mb-0">
				¡Reconoce a tus compañeros! Sé parte de esta iniciativa y mantengamos viva nuestra cultura.
				</p>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<div class="border-bottom mb-3 pb-3"></div>
			</div>
		</div>
		
		<div class="row">
			<div class="col-12 col-lg-4">
				<ReconoceColaboradoresList 
					:data="usuarios"
					@capturaColaborador="capturaColaborador"
					:loading="loadingColaboradores"
				/>
			</div>
			<form 
				@submit.prevent="cargarDatosModal"
				class="col-12 col-lg-8">
				
				<template v-if="!loadingColaboradores">
					<div class="card bg-main border-0 rounded-4 mb-4">
						<div class="card-body pt-0">
							<div class="d-flex justify-content-end">
								<img 
								height="22" 
								class="me-5"
								src="@/assets/img/intranet/reconoce/semicirculo-lineal-gris.svg"
								/>
							</div>
			
							<div class="d-flex align-items-center">
								<div class="flex-grow-1">
								<div class="d-flex align-items-center">
									<div class="flex-shrink-0">
									<img 
										v-if="colaborador.imagen_perfil || /.jpg|.jpeg|.png/.test(colaborador.imagen_perfil)"
										:src="colaborador.imagen_perfil"
										width="70"
										height="70"
										class="img-object-cover rounded-circle border border-white p-1"
									>
									<img
										v-else
										src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
										width="70"
										height="70"
										class="img-object-cover rounded-circle border border-white p-1"
									/>
									</div>
									<div class="flex-grow-1 ms-3">
									<h4 class="d-grid text-white mb-0">
										<strong class="ellipsis-custom">
										{{ capitalizeFirstLetter(colaborador.primer_nombre) }}
										{{ capitalizeFirstLetter(colaborador.apellido_paterno) }}
										</strong>
										<span class="fs-6 text-white text-opacity-75">
										{{ colaborador.cargo[0].nombre_cargo }}
										</span>
									</h4>
									</div>
								</div>
								</div>
								<div class="flex-shrink-0">
									<img
									width="80"
									height="80"
									src="@/assets/img/intranet/reconoce/img-card-reconocer@2x.png"
									/>
								</div>
							</div>
						</div>
					</div>
				</template>

				<div class="row">
					<div class="col-12">
						<h5 class="font-700 h5-custom font-main text-secondary border-bottom mb-4">
							Realiza tu reconocimiento
						</h5>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-6">
						<div class="row">
							<div class="col-12 mb-3">
								<label class="form-label text-secondary">
									Selecciona un valor
								</label>
								<v-select
									:options="valoresReconocimientos"
									v-model="form.valor"
									label="nombre_valor"
									placeholder="Seleccionar"
									class="vue-select"
									:class="{ 'vue-select-invalid': !validation.valor && errorForm }"
									:clearable="false"
								>
								</v-select>
							</div>
						</div>
						<div class="row">
							<div class="col-12 mb-3">
								<label class="form-label text-secondary">
									Selecciona relación laboral
								</label>
								<v-select
									:options="relacion_laboral"
									v-model="form.relacion"
									label="nombre_relacion"
									placeholder="Seleccionar"
									class="vue-select"
									:class="{ 'vue-select-invalid': !validation.relacion && errorForm }"
									:clearable="false"
								>
								</v-select>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label class="form-label text-secondary">
									Escribe el argumento de tu reconocimiento
								</label>
								<textarea 
									v-model="form.argumento"
									class="form-control textarea-height-110 resize-none"
									placeholder="Ingresa un argumento"
									:class="{'is-invalid': !validation.argumento && errorForm }"
									rows="3"></textarea>
								<div class="invalid-feedback">
									Debes agregar un argumento.
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<label class="form-label text-secondary">
							Agrega una imagen
						</label>
						<div class="card border-0">
							<div class="card-body">
								<UploadImageForm @capturaImagen="capturaImagen"/>
							</div>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-12 col-lg-8 d-flex align-items-center">
						<font-awesome-icon icon="fa-solid fa-circle-info" class="color-main me-2"></font-awesome-icon>
						<small class="text-secondary">Al finalizar, la persona será notificada y podrás ver el reconocimiento en el muro del módulo.</small>
					</div>
					<div class="col-12 col-lg-4 d-flex justify-content-end">
						<button
							type="submit"
							data-bs-toggle="modal"
							data-bs-target="#modal-nuevo-reconocimiento"
							:disabled="!isValid"
							class="btn btn-custom btn-custom-main rounded-pill mw-150"
						>
							Reconocer
						</button> 
					</div>
				</div>
			</form>
		</div>

		<template v-if="!loadingColaboradores">
			<ModalReconoceForm 
				:form="form"
				:colaborador="colaborador"
				@enviarReconocimiento="enviarReconocimiento"
			/>
		</template>
    <Spinner v-if="show_spinner" />
	</section>
</template>